import type { CurrencyCode } from "Models/CurrencyCodes";
import { formatCurrency } from "Utils/CurrencyUtils";

// The displayed currency must always match the currency the payment payload is
// stamped with (useAmount — the user's market region), so callers pass it down
// from useUserMarketCurrency instead of relying on any default.
export const formatPrice = (
  priceInCents: number,
  currencyCode: CurrencyCode | undefined,
) => {
  const amount = priceInCents / 100;

  return formatCurrency({
    amount,
    currencyCode,
    minDecimalPlaces: 2,
    maxDecimalPlaces: 2,
  });
};
